import Image from "next/image";
import React from "react";

const Hero: React.FC = () => {
  return (
    
      <div className="hero bg-gray-800 text-center py-4 px-4 mt-4 rounded-lg shadow-lg">
        <Image 
          src="/hero.png"
          alt="HeroImage"
          width="1350"
          height="100"
          className="rounded-lg mx-auto"
        />
        <Image 
            src="/hero2.png"
            alt="HeroImage"
            width="1350"
            height="100"
            className="rounded-lg mx-auto"
        />
      </div>
  );
};

export default Hero;